<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>THE PRICE PATCHWORK</h2>
        <p>
            <strong>Melbourne’s rental cost by neighbourhood.</strong>
        </p>
        <p>Mapping out the average two bedroom rental cost by postcode illuminates the radial decrease in housing prices as we move outward from the CBD – however this doesn’t occur at a consistent rate in all directions. Prices drop swiftly west of the CBD (contrast West Melbourne at $510 with neighbouring Footscray at $369), whereas they experience a more gentle decline towards the Northeast (see suburbs such as Templestowe).</p>
        <p>In addition, a ‘coastal premium’ is visible, with many Inner South postcodes that are adjacent to the coastline also maintaining high rents. The suburb of Brighton bucks the ‘radial decrease’ trend – commanding substantially higher rents than its northern neighbours of St Kilda and Elwood.</p>
        <p>Touch the map to explore more neighbourhoods.</p>
        <multiselect
            class="postcode__selector"
            :value="selectedPostcode"
            :options="data"
            track-by="postcode"
            label="label"
            @input="update_selected_postcode"
        ></multiselect>
    </div>
</template>

<script>
import tooltip_mixin from "@/assets/tooltip_mixin";
export default {
    props: {
        visible: {
            default: () => false
        }
    },
    mixins: [tooltip_mixin]
};
</script>

<style scoped>
.postcode__selector {
    width: 80%;
}
</style>
